import React from 'react';
import { Avatar, Box, Typography } from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import PersonIcon from '@mui/icons-material/Person';
import useStore from '../../store';

const formatTime = (timestamp) =>
    timestamp
        ? new Date(timestamp).toLocaleTimeString([], {
              hour: 'numeric',
              minute: '2-digit',
          })
        : null;

const formatLatency = (latencyMs) =>
    typeof latencyMs === 'number' ? `${(latencyMs / 1000).toFixed(1)}s` : null;

// Identity / meta line rendered above each chat bubble:
// assistant → sparkle avatar + "Prompta" + "10:42 AM · 2.3s",
// user → right-aligned initials avatar + display name + timestamp
// (no latency — only meaningful for AI responses).
const ChatMessageMeta = ({ message }) => {
    const activeUser = useStore((state) => state.activeUser);
    const time = formatTime(message?.createdAt);

    if (message?.role === 'user') {
        const displayName =
            [activeUser?.first_name, activeUser?.last_name]
                .filter(Boolean)
                .join(' ') || 'You';
        const initials =
            `${activeUser?.first_name?.[0] || ''}${activeUser?.last_name?.[0] || ''}`.toUpperCase();

        return (
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                    gap: 0.75,
                    mb: 0.25,
                    mr: 0.5,
                }}
            >
                {time && (
                    <Typography sx={{ fontSize: 11, color: 'text.disabled' }}>
                        {time}
                    </Typography>
                )}
                <Typography
                    sx={{ fontSize: 12, fontWeight: 600, color: 'text.secondary' }}
                >
                    {displayName}
                </Typography>
                <Avatar
                    sx={{
                        width: 18,
                        height: 18,
                        bgcolor: 'grey.400',
                        fontSize: 9,
                        fontWeight: 600,
                    }}
                >
                    {initials || <PersonIcon sx={{ fontSize: 11 }} />}
                </Avatar>
            </Box>
        );
    }

    const latency = formatLatency(message?.latencyMs);
    const meta = [time, latency].filter(Boolean).join(' · ');

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 0.75,
                mb: 0.25,
                ml: 0.25,
            }}
        >
            <Avatar
                sx={{
                    width: 18,
                    height: 18,
                    background: 'linear-gradient(135deg, #1859d4 0%, #4f8af7 100%)',
                }}
            >
                <AutoAwesomeIcon sx={{ fontSize: 11, color: '#fff' }} />
            </Avatar>
            <Typography
                sx={{ fontSize: 12, fontWeight: 600, color: 'primary.main' }}
            >
                Prompta
            </Typography>
            {meta && (
                <Typography sx={{ fontSize: 11, color: 'text.disabled' }}>
                    {meta}
                </Typography>
            )}
        </Box>
    );
};

export default ChatMessageMeta;
